import 'zone.js';
import { CommonModule } from '@angular/common';
import { environment } from './environments/environment';
import { providePrimeNG } from 'primeng/config';
import { MyPreset } from './app/shared/theme';
import { MessageService, ConfirmationService } from 'primeng/api';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import {
  createHttpInterceptor,
  googleMapsInitializer,
  primeNgTranslationInitializer,
  provideGoogleMapsApiKey,
  provideTranslocoRoot,
} from '@rieaya-core';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { routes } from './app/app.routes';
import { ApiModule, Configuration } from '@rieaya-laundry-api';
// provideAnimations is unnecessary when using provideAnimationsAsync
import { ToastModule } from 'primeng/toast';
import { AppComponent } from './app/app.component';
import { importProvidersFrom } from '@angular/core';
import { LANG, TOKEN } from './app/core/utils/constant';

const httpInterceptor = createHttpInterceptor({
  tokenKey: TOKEN,
  langKey: LANG,
  panel: 3,
});

bootstrapApplication(AppComponent, {
  providers: [
    provideHttpClient(withInterceptors([httpInterceptor])),
    importProvidersFrom(
      ApiModule.forRoot(
        () =>
          new Configuration({
            basePath: environment.apiUrl,
          })
      ),
      CommonModule,
      ToastModule
    ),
    provideRouter(
      routes,
      withInMemoryScrolling({ scrollPositionRestoration: 'top' })
    ),
    providePrimeNG({
      theme: {
        preset: MyPreset,
        options: {
          darkModeSelector: '.dark',
        },
      },
    }),
    MessageService,
    ConfirmationService,
    provideAnimationsAsync(),
    provideGoogleMapsApiKey(environment),
    googleMapsInitializer(environment),
    primeNgTranslationInitializer(),
    provideTranslocoRoot('en'),
  ],
})
  .then(() => registerLaundryPanelServiceWorker())
  .catch((err) => console.error(err));

function registerLaundryPanelServiceWorker(): void {
  if (!('serviceWorker' in navigator)) {
    return;
  }

  window.addEventListener('load', () => {
    const scriptUrl = new URL('laundry-panel-sw.js', document.baseURI);
    navigator.serviceWorker.register(scriptUrl.toString()).catch(console.error);
  });
}
